import { ds } from 'mewe/stores/ds';
import { set } from '@ember/object';
import { toQuest } from 'mewe/fetchers/utils';
import QuestApi from 'mewe/api/quest-api';

export default function () {
  // don't fetch more than once every 3 seconds if user navigates back and forth
  const lastFetchedAt = ds.questState.lastFetchedAt;
  if (lastFetchedAt && lastFetchedAt > Date.now() - (1000 * 3)) return;

  set(ds.questState, 'lastFetchedAt', Date.now());
  set(ds.questState, 'isFetching', true);
  set(ds.questState, 'isLoaded', false);

  QuestApi.getQuestState().then((res) => {
    // if no levels, then user is not included in gamification - registered before we launched it
    if (res.levels?.length) {
      ds.questState.levels = res.levels.map(toQuest);
      set(ds.questState, 'isLoaded', true);
    }

    set(ds.questState, 'isFetching', false);
  }).catch((error) => {
    console.error('Failed to fetch quests:', error);
    if (error && error.status >= 500) {
      Sentry.captureException(new Error(`Quest state fetch failed: ${error.message}`), {
        extra: { status: error.status, data: error.data }
      });
    }
    set(ds.questState, 'isFetching', false);
    set(ds.questState, 'isLoaded', false);
  });
}
